import { appEnvPrefix } from './general'

export const appS3Bucket = {
  bucket: 'sparx-cdn',
  region: 'us-east-2',
}

export function getS3PathPrefix() {
  return process.env.REACT_APP_CDN_HOST || `https://storage.googleapis.com/sparx-cdn` 
}

export function getCdnAssetUrl(path) {
  const reg = new RegExp('^(?:[a-z+]+:)?//', 'i')
  // Check for absolute URL
  if (reg.test(path)) {
    return path
  } else {
    // Generate absolute CDN url for relative path
    return `https://cdn.sparx.ai/${path}`
  }
}
